var map = {
	"./Default": 59258,
	"./Default.tsx": 59258,
	"./Detailed": 50665,
	"./Detailed.tsx": 50665,
	"./Mobilecard": 8657,
	"./Mobilecard.tsx": 8657,
	"./Mobilecardtwo": 49043,
	"./Mobilecardtwo.tsx": 49043,
	"./Mobiletwocolumn": 90231,
	"./Mobiletwocolumn.tsx": 90231,
	"./type": 29224,
	"./type.ts": 29224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43627;